import { render, staticRenderFns } from "./expire-link.vue?vue&type=template&id=52d65be6&scoped=true&"
import script from "./expire-link.vue?vue&type=script&lang=js&"
export * from "./expire-link.vue?vue&type=script&lang=js&"
import style0 from "./expire-link.vue?vue&type=style&index=0&id=52d65be6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d65be6",
  null
  
)

component.options.__file = "expire-link.vue"
export default component.exports